import type { LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export const Label = ({ className, required = false, children, ...props }: LabelProps) => (
  <label className={cn('block text-base font-semibold text-navy', className)} {...props}>
    {children}
    {required && (
      <span className="ml-1 text-danger" aria-hidden="true">
        *
      </span>
    )}
  </label>
);
